module.exports = __webpack_public_path__ + "img/ceramic-green.a0c8513a.png";